import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import SetupPortalPage from '../../components/setup/SetupPortalPage';
import WorkflowForm from '../../components/workflows/WorkflowForm';
import api from '../../API.js';
import styles from '../../styles/workflows.module.css';
import { AGENT_SETUP_BASE } from '../../constants/setupRoadmapSteps';

function WorkflowEdit() {
    const { workflowId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [workflow, setWorkflow] = useState(null);

    useEffect(() => {
        if (workflowId) {
            fetchWorkflow();
        }
    }, [workflowId]);

    const fetchWorkflow = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await api.get(`workflow/${workflowId}`);
            
            if (response.status === 404) {
                setError('Workflow not found. It may have been deleted.');
                setLoading(false);
                return;
            }
            
            if (response.status !== 200) {
                throw new Error(`Failed to fetch workflow: ${response.status}`);
            }

            if (response.data.success) {
                setWorkflow(response.data.workflow);
            } else {
                throw new Error('Failed to load workflow');
            }
        } catch (err) {
            console.error('Error fetching workflow:', err);
            setError('Failed to load workflow: ' + (err.message || 'Unknown error'));
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (formData) => {
        try {
            const response = await api.put(`workflow/${workflowId}`, { body: formData });
            
            if (response.status !== 200) {
                let errorMessage = `HTTP error! status: ${response.status}`;
                if (response.data) {
                    if (typeof response.data === 'string') {
                        errorMessage = response.data;
                    } else if (response.data.message) {
                        errorMessage = response.data.message;
                    } else if (response.data.error) {
                        errorMessage = response.data.error;
                    }
                }
                throw new Error(errorMessage);
            }

            navigate(`${AGENT_SETUP_BASE}/workflows`);
        } catch (err) {
            throw err;
        }
    };

    if (loading) {
        return (
            <SetupPortalPage>
                <div className={styles.loading}>Loading workflow...</div>
            </SetupPortalPage>
        );
    }

    if (error && !workflow) {
        return (
            <SetupPortalPage>
                <div className={styles.container}>
                    <div className={styles.error}>
                        {error}
                    </div>
                    <Link
                        to={`${AGENT_SETUP_BASE}/workflows`}
                        className={styles.button}
                        style={{ marginTop: '1em', display: 'inline-block' }}
                    >
                        Back to Workflows
                    </Link>
                </div>
            </SetupPortalPage>
        );
    }

    return (
        <SetupPortalPage>
            <div className={styles.container}>
                <div style={{ marginBottom: '2em' }}>
                    <Link
                        to={`${AGENT_SETUP_BASE}/workflows`}
                        style={{
                            color: '#007bff',
                            textDecoration: 'none',
                            fontSize: '14px',
                        }}
                    >
                        ← Back to Workflows
                    </Link>
                </div>

                <h1>Edit Workflow: {workflow?.name}</h1>

                {error && (
                    <div className={styles.error}>
                        {error}
                    </div>
                )}

                {workflow && (
                    <WorkflowForm
                        workflow={workflow}
                        onSubmit={handleUpdate}
                        onCancel={() => navigate(`${AGENT_SETUP_BASE}/workflows`)}
                    />
                )}
            </div>
        </SetupPortalPage>
    );
}

export default WorkflowEdit;
